import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../assets/logo.svg'


const _hoisted_1 = { style: {"position":"fixed","width":"100%","z-index":"30","background-color":"rgba(255, 255, 255, 0.05)","backdrop-filter":"blur(10px)"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"30px","position":"absolute","left":"15px","top":"20px"},
  src: _imports_0
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"70px"} }, null, -1)

import { ref, onMounted } from "vue";
import { appStore } from '@/store/appStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeadMenu',
  setup(__props) {

const store = appStore()
const show = ref(false)
const menu = [
    { icon: "#ri-home-smile-2-line", text: "调整图片", page: "image-resize" },
    // { icon: "#crop", text: "图像裁剪", page: "image-crop" },
    { icon: "#ri-artboard-2-line", text: "批量调整", page: "all-zh" },
    { icon: "#ri-box-2-line", text: "应用介绍", page: "about" },
    { icon: "#ri-settings-line", text: "应用设置", page: "settings" },
]

onMounted(() => {
    // show.value = true;
    setTimeout(() => {
        show.value = true;
    }, 200)
})

function change(item) {
    store.pageKey = item.page;
}

return (_ctx: any,_cache: any) => {
  const _component_x_icon = _resolveComponent("x-icon")!
  const _component_x_label = _resolveComponent("x-label")!
  const _component_x_tab = _resolveComponent("x-tab")!
  const _component_x_tabs = _resolveComponent("x-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createVNode(_component_x_tabs, {
        value: _unref(store).pageKey,
        style: {"height":"70px"}
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menu, (item, index) => {
            return _createVNode(_component_x_tab, {
              onClick: ($event: any) => (change(item)),
              key: index,
              value: item.page
            }, {
              default: _withCtx(() => [
                _createVNode(_component_x_icon, {
                  href: item.icon
                }, null, 8, ["href"]),
                _createVNode(_component_x_label, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.text), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["onClick", "value"])
          }), 64))
        ]),
        _: 1
      }, 8, ["value"]), [
        [_vShow, show.value]
      ])
    ]),
    _hoisted_3
  ], 64))
}
}

})